import { render, staticRenderFns } from "./CameraAcquisition.vue?vue&type=template&id=540295de&scoped=true"
import script from "./CameraAcquisition.vue?vue&type=script&lang=js"
export * from "./CameraAcquisition.vue?vue&type=script&lang=js"
import style0 from "./CameraAcquisition.vue?vue&type=style&index=0&id=540295de&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540295de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540295de')) {
      api.createRecord('540295de', component.options)
    } else {
      api.reload('540295de', component.options)
    }
    module.hot.accept("./CameraAcquisition.vue?vue&type=template&id=540295de&scoped=true", function () {
      api.rerender('540295de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/PsychologicalMonthReport/components/CameraAcquisition.vue"
export default component.exports